module.exports = __webpack_public_path__ + "img/Image31.79bb1142.jpg";